import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "18",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FC0",
  stroke: "#EBEBEB",
  d: "M22.867.5H3.133A2.633 2.633 0 0 0 .5 3.133v11.734A2.633 2.633 0 0 0 3.133 17.5h19.734a2.633 2.633 0 0 0 2.633-2.633V3.133A2.633 2.633 0 0 0 22.867.5Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "red",
  d: "M11.5 7.912V4H7.33v2.97H4.5v4.06h2.83V14h4.17v-3.912h-.992v2.97H8.321v-2.97H5.49V7.912h2.83v-2.97h2.187v2.97h.992Z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M18.421 7.56c0 .71-.671 1.264-1.523 1.264h-1.296V6.382h1.296c.885 0 1.523.497 1.523 1.178M17.455 4H12.5v10h3.102v-2.97h1.853c2.276 0 4.045-1.516 4.045-3.473C21.5 5.586 19.699 4 17.455 4"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }